
import { FILTER_CONFIG, LAYER_DISPLAY_ORDER } from '@/constants/filter.constants';

export class FilterService {
  static isSpecialPortfolio(portfolioId) {
    return FILTER_CONFIG.SPECIAL_PORTFOLIOS.includes(portfolioId);
  }

  static filterPortfolios(portfolios, isMobile) {
    if (isMobile) {
      return portfolios;
    }
    
    const excludedIds = new Set(FILTER_CONFIG.EXCLUDED_PORTFOLIOS.DESKTOP);
    return portfolios.filter(portfolio => !excludedIds.has(portfolio.id));
  }

  static processLayerTranslations(layers, getTranslations) {
    const order = LAYER_DISPLAY_ORDER;
    return layers
      .map(layer => ({
        ...layer,
        translation: this.getLayerTranslation(layer.name, getTranslations),
      }))
      .sort((a, b) => {
        const indexA = order.indexOf(a.id);
        const indexB = order.indexOf(b.id);
        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;
        return a.translation.toLowerCase().localeCompare(b.translation.toLowerCase());
      });
  }

  static getLayerTranslation(layerName, getTranslations) {
    const cleanName = layerName.replace(/-/g, ' ').replace(/&nbsp;/g, ' ');
    return getTranslations(cleanName);
  }

  static generateMenuLabel(activeLayer, activePortfolio, getTranslations) {
    if (activeLayer.id === FILTER_CONFIG.SOLUTIONS_LAYER_ID) {
      return `${getTranslations('solutions')} - ${activePortfolio?.name}`;
    }
    
    return this.getLayerTranslation(activeLayer.name, getTranslations);
  }

  static shouldShowSolutionsSection(expanded, activeLayerId) {
    return expanded && activeLayerId === FILTER_CONFIG.SOLUTIONS_LAYER_ID;
  }

  static getContainerHeight(expanded, activeLayerId) {
    if (!expanded) return FILTER_CONFIG.DIMENSIONS.COLLAPSED_HEIGHT;
    
    return activeLayerId === FILTER_CONFIG.SOLUTIONS_LAYER_ID
      ? FILTER_CONFIG.DIMENSIONS.EXPANDED_HEIGHT_SOLUTIONS
      : FILTER_CONFIG.DIMENSIONS.EXPANDED_HEIGHT_OTHER;
  }
}